import React, { createContext, useContext } from "react";
import { useUser } from "../../../hooks/useUser";
import { Navigate } from "react-router-dom";
import LoadingPage from "../../LoadingPage/LoadingPage";
import { useTranslation } from "react-i18next";

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

const AuthRequiredRoute = ({ children }) => {
  const authValue = useUser();
  const { t } = useTranslation("selectLoan");
  if (authValue.isLoading) {
    return <LoadingPage message={t("loading")} />;
  }

  console.log(authValue.userData);

  if (!authValue.userData) {
    const searchParams = new URLSearchParams(window.location.search);
    const token = searchParams.get("token");

    const redirectTo = token
      ? `/register?token=${encodeURIComponent(token)}`
      : "/register";

    return <Navigate to={redirectTo} />;
  }

  return (
    <AuthContext.Provider value={authValue}>{children}</AuthContext.Provider>
  );
};

export default AuthRequiredRoute;
